import misRutas from 'vue-routes-generator'
import InvitacionesComponent from './main'
// Exportamos
export default {
	install: Vue => {
		misRutas.route('/main').child('invitaciones', {
			name: 'Gestión de invitaciones',
			component: InvitacionesComponent
		})
	}
}



// WEBPACK FOOTER //
// ./src/modulos/invitaciones/vue/index.js